import { RestaurantTagCreate } from "../../Component/RestaurantTag/RestaurantTagCreate";
import { constants } from "../../Constants/constants";

import "../../styles/map.css";

export const RestaurantCategoryCreate = () => {
  return (
    <RestaurantTagCreate resource={constants.PATH.RESTAURANT_TAG.RESTAURANT_CATEGORY} resourceName="restaurant_category" />
  );
};
